import React, { FC } from "react";
import { Header as CommonHeader } from "components/Header";
import { ScreenerAccess } from "containers/ScreenerAccess";
import { SubHeader } from "containers/SuccessSubmit/components/SubHeader";
import { CandidateChecks } from "./components/CandidateChecks";
import { PageWrapper } from "containers/SuccessSubmit/components/PageWrapper";
import { SuccessfullySubmittedCaseInformation } from "containers/SuccessSubmit/components/SuccessfullySubmittedCaseInformation";
import { CandidateCaseStatus } from "src/graphQLTypes";
import {
  useGetCaseInformation,
  useSurvicate,
  useProductActionAnswerDrawerControls
} from "containers/SuccessSubmit/hooks";
import { Spinner } from "components/common/Spinner";
import { ProductActionAnswerDetails } from "containers/SuccessSubmit/components/ProductActionAnswerDetails";
import { getCaseStatus } from "containers/SuccessSubmit/utils/getCaseStatus";
import { MetaData } from "components/MetaData";
import { WithdrawnByInactivityCaseInformation } from "./components/WithdrawnByInactivityCaseInformation";
import { useUrlSearchParams } from "src/hooks/useUrlSearchParams";

const SuccessSubmitNewComponent: FC = () => {
  useSurvicate();

  const { caseId } = useUrlSearchParams();

  const { data, isLoading, refetch } = useGetCaseInformation(caseId);

  const caseStatus = getCaseStatus(data?.status, data?.products);

  const drawerControls = useProductActionAnswerDrawerControls();

  const candidateName = `${data?.candidate.firstName} ${data?.candidate.lastName}`;

  const isCaseCompleted = data?.status === CandidateCaseStatus.INACTIVE;

  const isCaseWithdrawnByInactivity =
    data?.status === CandidateCaseStatus.WITHDRAWN_BY_INACTIVITY;

  if (isLoading) {
    return (
      <>
        <CommonHeader />
        <Spinner />
      </>
    );
  }

  const renderBody = () => {
    if (isCaseCompleted) {
      return (
        <PageWrapper>
          <SuccessfullySubmittedCaseInformation
            clientName={data?.client.name}
            candidateName={candidateName}
            assigneeName={data?.assignee?.name ?? null}
          />
        </PageWrapper>
      );
    }

    if (isCaseWithdrawnByInactivity) {
      return (
        <PageWrapper>
          <WithdrawnByInactivityCaseInformation />
        </PageWrapper>
      );
    }

    return (
      <>
        <SubHeader
          candidateName={candidateName}
          clientName={data?.client.name}
          assigneeName={data?.assignee?.name ?? null}
          caseStatus={caseStatus}
        />

        <ScreenerAccess />

        <PageWrapper>
          <CandidateChecks
            onActionClick={drawerControls.onOpen}
            products={data?.products || []}
            caseStatus={caseStatus}
          />
        </PageWrapper>
      </>
    );
  };

  return (
    <>
      <MetaData title="Screening finished" />
      <CommonHeader />

      <ProductActionAnswerDetails
        isOpen={drawerControls.isOpen}
        onClose={drawerControls.onClose}
        product={drawerControls.product}
        refetchCase={refetch}
      />

      {renderBody()}
    </>
  );
};

export const SuccessSubmitNew = React.memo(SuccessSubmitNewComponent);
